import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { getFieldValue } from '../../../utils';
import { useSelector } from '../../../utils/useSelector';
import { CharacterCount } from '../CharacterCount/characterCount';

export const TextField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, updateData } = updater;
  const isMyItemsView = useSelector(s => s.view?.selected?.isMyItemsView);
  const value = getFieldValue(field, data);

  const shouldMask = !!isMyItemsView && field?.key == `Item.title`;
  return (
    <FieldGroup
      {...props}
      value={value}
      componentRight={
        field?.key == `Item.title` ? (
          <CharacterCount value={value} max={255} />
        ) : !!field?.maxCharCount ? (
          <CharacterCount value={value} max={field.maxCharCount} />
        ) : null
      }
    >
      <input
        type="text"
        className={`form-control form-control-sm ${
          !!shouldMask ? 'fs-mask' : ''
        }`}
        value={value}
        onBlur={(e: any) => {
          updateData(field, e.target.value);
        }}
        onChange={(e: any) => {
          updateField(field, e.target.value);
        }}
      />
    </FieldGroup>
  );
};
